/* @flow weak */

'use strict';

const React = require('react');
const Reflux = require('reflux');

const AnswerActions = require('../../actions/AnswerActions.jsx');

const ControlMixin = require('../../mixins/ControlMixin.jsx');

const QuestionStore = require('../../stores/QuestionStore.jsx');
const ValidatorStore = require('../../stores/ValidatorStore.jsx');

const _ = require('lodash');

const SaveLink = React.createClass({
  mixins: [ControlMixin, Reflux.listenTo(ValidatorStore, "onValidatorChange")],

  siblingQuestions: [],
  showAsButton: false,
  linkText: 'Save',

  componentWillMount() {
    this.siblingQuestions = _.filter(QuestionStore.getChildQuestions(this.props.question.parent_id), siblingQuestion => {
      return this.props.question.id !== siblingQuestion.id;
    });

    this.showAsButton = !!_.get(this.props.question, 'metadata.control.SaveLink.ShowAsButton');
    this.linkText = _.get(this.props.question, 'metadata.control.SaveLink.CustomText') || 'Save';
  },

  onValidatorChange(validationData) {
    let hasVisibleSiblings = _.some(this.siblingQuestions, (question) => {
      return validationData.questions[question.id].visible;
    });

    let allRequiredSiblingsAnswered = false;

    if (hasVisibleSiblings) {
      allRequiredSiblingsAnswered = _.every(this.siblingQuestions, question => {
        let valid = _.get(validationData.questions[question.id], 'valid');
        return valid || valid === undefined;
      });
    }

    this.setState({
      linkVisible: hasVisibleSiblings,
      linkActive: allRequiredSiblingsAnswered
    });
  },

  handleSaveClick() {
    // return this.state.linkActive ? this.scrollToQuestion('CharmSelectionControlGrid') : false;
    // return this.state.linkActive ? this.handleScroll() : false;
    if (!this.state.linkActive) {
      return false;
    }

    AnswerActions.delete(QuestionStore.getQuestionByName('CharmSelectionControlGrid'));
    return this.scrollToQuestion('CharmSelectionControlGrid', 'top')
  },

  render() {
    let classNames = 'uc-control uc-save-link' + (this.showAsButton ? ' uc-save-link-button' : '');

    return (
      <div className={classNames} style={{ display: this.state.linkVisible ? 'block' : 'none' }}>
        <a onClick={this.handleSaveClick} className={this.state.linkActive ? 'uc-active' : ''}>{this.linkText}</a>
      </div>
    );
  }
});

module.exports = SaveLink;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/SaveLink.jsx